'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var ButtonPlain = require('../../01.atoms/ButtonPlain/ButtonPlain.js');
var List = require('../../03.organisms/List/List.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-teaser-list',
    cnItems = "".concat(CLASSNAME, "__items"),
    cnButtons = "".concat(CLASSNAME, "__buttons");
/**
 * 
 * @param {*} param0 
 * @returns 
 */

function TeaserList(_ref) {
  var className = _ref.className,
      i18n = _ref.i18n,
      items = _ref.items,
      linkAll = _ref.linkAll;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(CLASSNAME, className)
  }, items && /*#__PURE__*/React__default.createElement("div", {
    className: cnItems
  }, /*#__PURE__*/React__default.createElement("h2", null, i18n.title), /*#__PURE__*/React__default.createElement(List, {
    items: items,
    i18n: i18n
  }), /*#__PURE__*/React__default.createElement("div", {
    className: cnButtons
  }, /*#__PURE__*/React__default.createElement(ButtonPlain, {
    title: i18n.viewAll,
    link: linkAll
  }))));
}
TeaserList.propTypes = {
  /** Additional class name */
  className: PropTypes.string,

  /** Translation object */
  i18n: PropTypes.shape(_rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, List.propTypes.i18n), {}, {
    viewAll: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired
  })).isRequired,

  /** Array of items */
  items: PropTypes.array,

  /** Link on button */
  linkAll: PropTypes.string
};
TeaserList.defaultProps = {
  i18n: {}
};

module.exports = TeaserList;
